import { Formik } from "formik"
import { Button, Form, Col, Row } from "react-bootstrap"
import { useHistory } from "react-router-dom"
import { axiosPrivate } from "../../../../api/axios"

import { RoutePaths } from "../../../../routes/RoutePaths"
import FormikSelect, {
  TSelectFieldOptions
} from "../../../shared/form/component/formFields/FormikSelect"
import AllTextState from "../../../shared/state/AllTextState"
import {
  getCurrentUserTenantId,
  getUserInfo,
  setUserInformation,
  setUserPermission
} from "../../app/state/appSessionStorage"
import { useEffect, useState } from "react"
import Toast from "../../../shared/ui/notification/Toast"
import { getUserPermission } from "../../app/state/appSessionStorage"
import SubmittingSpinner from "../../shared/SubmittingSpinner"

interface IProps {
  closeFunc: any;
  tenants: any;
}

const SwitchTenantModal = (props: IProps): JSX.Element => {
  const history = useHistory()
  const [tenantChanged, setTenantChanged] = useState<any>()

  const tenantOptions: TSelectFieldOptions = props.tenants.map((key: any) => {
    return {
      value: key.tenantId,
      label: key.tenantName
    }
  })
  useEffect(() => {
    if (tenantChanged) {
      const userInfo = getUserInfo()
      userInfo.currentTenantName = tenantChanged[0].label
      setUserInformation(userInfo)
      const userTempTenantId = getUserPermission()
      userTempTenantId.currentTenant = tenantChanged[0].value
      setUserPermission(userTempTenantId)
    }
  }, [tenantChanged])

  const currentTenantInitial = {
    currentTenant: getCurrentUserTenantId()
  }

  return (
    <>
      {AllTextState.switchTenant}
      <div style={{ height: "250px",
        width: "300px" }}>
        <Formik
          enableReinitialize
          initialValues={currentTenantInitial}
          onSubmit={(values, { setSubmitting }): any => {
            // When button submits form and form is in the process of submitting, submit button is disabled
            setSubmitting(true)
            axiosPrivate
              .get(`/rest/switch_tenant/${values.currentTenant}`)
              .then((response: any) => {
                if (response.status === 200) {
                  const tenant = tenantOptions.filter(
                    (tenant) => tenant.value === values.currentTenant
                  )
                  setTenantChanged(tenant)
                  history.push({
                    pathname: RoutePaths.DASHBOARD
                  })
                  Toast("Switched Tenant Successfully", "success")
                }
              })
              .catch((error) => {
                console.error(error)
                Toast("Failed To Switch Tenant", "error")
              })

            props.closeFunc()
            // Sets setSubmitting to false after form is reset
            setSubmitting(false)
          }}
        >
          {(formikProps: any): any => {
            return (
              <Form onSubmit={formikProps.handleSubmit}>
                <Row>
                  <Col md={12}>
                    <FormikSelect
                      title="currentTenant"
                      options={tenantOptions}
                      placeholderText="Select . . ."
                      formikProps={formikProps}
                    />
                  </Col>
                </Row>
                <Row className="justify-content-center m-t-20">
                  <Col md="auto">
                    <Button
                      variant="primary"
                      type="submit"
                      disabled={!formikProps.dirty || formikProps.isSubmitting}
                    >
                      {formikProps.isSubmitting ? (
                        <SubmittingSpinner text="Submitting" />
                      ) : (
                        'Submit'
                      )}
                    </Button>
                  </Col>
                </Row>
              </Form>
            )
          }}
        </Formik>
      </div>
    </>
  )
}

export default SwitchTenantModal
